import * as v from 'valibot';
import { portalAccessSchema } from './windowPortalAccess';

export const windowCCBUserInfoSchema = v.fallback(
  v.object({
    sessionStart: v.optional(v.string()),
    social: v.optional(
      v.object({
        facebookEnabled: v.optional(v.boolean()),
        facebookConnected: v.optional(v.boolean()),
        linkedinEnabled: v.optional(v.boolean()),
        googleEnabled: v.optional(v.boolean()),
        googleConnected: v.optional(v.boolean()),
        linkedinConnected: v.optional(v.boolean()),
      }),
    ),
    t24h: v.optional(v.boolean()),
    portalAccess: portalAccessSchema,
    last_name: v.optional(v.string()),
    elevio_hash: v.optional(v.string()),
    locale: v.optional(v.string()),
    uid: v.optional(v.number()),
    aleTheme: v.optional(v.string()),
    suser: v.optional(v.boolean()),
    name: v.optional(v.string()),
    sow: v.optional(v.string()),
    realm: v.optional(v.string()),
    first_name: v.optional(v.string()),
    email: v.optional(v.string()),
    since: v.optional(v.string()),
    pageLoad: v.optional(v.string()),
    adminLocale: v.optional(v.string()),
  }),
  {},
);

export type WindowUserInfo = v.Output<typeof windowCCBUserInfoSchema>;
